import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Amplify, Auth } from 'aws-amplify';
import { MarketService } from '../../shared/services/market.service';
import { scaleIn } from '../../shared/animations/modal.animation';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'], 
  animations: [scaleIn]
})
export class SigninComponent implements OnInit {

  registerForm: FormGroup;

  @Output() closeLogin: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() visible: boolean;
  isLoading: boolean;
  errorMessage: any;
  successMessage: any; 
  emailErr: any;
  usernameErr: any;
  passwordErr: any;
  passwordNotMatchErr: any;
  passwordStrengthErr: any;
  success: boolean;
  code_success: boolean; 
  public showConfFields: boolean;
  public showNormalFields: boolean = true;
  public user: any;
  public isShown: boolean; 
  public noMatchPwd: boolean; 

  constructor(@Inject(DOCUMENT) private document, private formBuilder: FormBuilder, private marketService: MarketService) {
    this.registerForm = this.formBuilder.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      email: ['', [Validators.required]],
      cellphone: ['', [Validators.required]],
      pwd: ['', [Validators.required]],
      confPwd: ['', [Validators.required]],
      code: ['', [Validators.required]]
    })
  }


  ngOnInit() {
    this.showConfFields = false;
    this.showNormalFields = true;
  }

  submit() {

    Amplify.configure(
      {
        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: 'us-east-1:d3708511-4409-4327-be18-47452870133d',

        // REQUIRED - Amazon Cognito Region
        region: 'us-east-1',

        // OPTIONAL - Amazon Cognito Federated Identity Pool Region 
        // Required only if it's different from Amazon Cognito Region
        identityPoolRegion: 'us-east-1',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'us-east-1_kc0P4U7YH',

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: '2r1j7mbji23eo4qoujo8ncm1dd',

        // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
        mandatorySignIn: false
      }
    );

    const regObject = {
      username: this.registerForm.value.email,
      firstname: this.registerForm.value.firstname,
      email: this.registerForm.value.email,
      password: this.registerForm.value.pwd,
      confirmPwd: this.registerForm.value.confPwd,
      cell: this.registerForm.value.cellphone,
      lastname: this.registerForm.value.lastname
    };

    // console.log('registration Object => ', regObject);

    if(regObject.password !== regObject.confirmPwd) {
      this.noMatchPwd = true; 
    }

    this.SignUp(regObject.username, regObject.email, regObject.password, regObject.confirmPwd, regObject.lastname,
      regObject.firstname);

  }

  async SignUp(username, email, password, confirmPassword, family_name, name) {

    this.isLoading = true;
    if (email === "") {
      this.isLoading = false;
      this.errorMessage = this.emailErr;
    }
    else if (username === "") {
      this.isLoading = false;
      this.errorMessage = this.usernameErr;
    }
    else if (password === "") {
      this.isLoading = false;
      this.errorMessage = this.passwordErr;
    }
    else if (password !== confirmPassword) {
      this.isLoading = false;
      this.errorMessage = this.passwordNotMatchErr;
    }
    else {

      Auth.signUp({
        username,
        password,
        attributes: {
          email, family_name, name
        },
        validationData: []  //optional
      })
        .then(data => {

          const propObject = {
            username: this.registerForm.value.email
          }
          this.user = data;
          // console.log("Data: ", data);
          this.noMatchPwd = false; 
          this.addUserToPropertiesGroup(propObject);   
          this.isLoading = false;     
          this.success = true;  
          this.success = true;   
          // setTimeout(() => {
          //   this.success = false;
          // }, 3000);
          this.onShowConfirmationFields();
          

          // if(data.userConfirmed){
          //   this.createCustomer(username, email);
          // }else {

          //this.bearer = (await Auth.currentSession()).getIdToken ().getJwtToken();
          //localStorage.setItem('customertoken', this.bearer);
          // }
        })
        .catch(err => {

          this.isLoading = false;
          if (err.message.includes("validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6") ||
            err.message.includes("Password did not conform with policy: Password not long enough")) {
            this.errorMessage = this.passwordStrengthErr;
          }
          else {
            this.errorMessage = err.message;
            //nothing
          }
          console.log("Error:: " , err.message);


        });
    }


  }
  onShowConfirmationFields() {
    this.showConfFields = true;
    this.showNormalFields = false
  }

  confirmSignUp() {

    this.signUpConfirmation(this.registerForm.value.email, this.registerForm.value.code);
    
    // setTimeout(() => {  
    //   this.close()
    // },3000);
     
  }

  async signUpConfirmation(username: string, code: string) {

    // console.log("Username :: ", username);
    // console.log("Code ::  ", code);
    this.isLoading = true;
    this.errorMessage = "";

    Auth.confirmSignUp(username, code, {
      // Optional. Force user confirmation irrespective of existing alias. By default set to True.
      forceAliasCreation: true
    })
      .then(data => {
        // console.log(data);
        // this.addUserToPropertiesGroup(username); 
        if (data === "SUCCESS") {
          this.sendWelcomeEmail(this.registerForm.value.email);
          this.success = false; 
          this.code_success = true; 
          // this.createPropertyOwner(username, this.registerForm.value.email);
          //testing pipeline
          // console.log('User confirmed !!!')
        }; 

        if(this.errorMessage = "An account with the given email already exists.") {
          this.errorMessage = false; 
        }
      })
      .catch(err => {
        this.isLoading = false;
        // console.log(err);
        this.errorMessage = err.message;
      });
  }

  createPropertyOwner(username: string, email: any) {
    throw new Error("Method not implemented.");
  }

  addUserToPropertiesGroup(email: any) {
    const propertyObject = {
      username: email
    };
    // console.log('property Object => ', propertyObject);
    this.marketService.addToPropertiesGroup(propertyObject.username)
      .subscribe(
        (data) => {
          // console.log('User added to properties Group... data => ', data)
        },
        (error) => {
          // console.log('Error => ', error)
        }
      )
  }
 
  addUserToSponsorsGroup(email: any) {
    const sponsorsObject = {
      username: email
    };
    // console.log('sponsorsObject => ', sponsorsObject);

    this.marketService.addToSponsorsGroup(sponsorsObject.username)
      .subscribe(
        (data) => {
          // console.log('user added to sponsors group...data => ', data)
        },
        (error) => {
          // console.log('Error ==> ', error);
        }
      )
  }

  createUser() {
    const userObject = {
      username: this.registerForm.value.email,
      email: this.registerForm.value.email,
      password: this.registerForm.value.password,
      phone: this.registerForm.value.cellphone
    };

    // console.log('userObject => ', userObject);

    this.marketService.creatUser(userObject)
      .subscribe(
        (data) => {
          // console.log('user created ', data);
        },
        (error) => {
          // console.log('Error =>', error);
        }
      )
  }

  sendWelcomeEmail(emailAddress: any){
    var sendEmailObject = {
      "email": emailAddress
    }
    console.log("sendEmailObject", sendEmailObject);
    
    this.marketService.sendWelcomeEmailRespondent(sendEmailObject).subscribe((data) => {
      console.log("sendWelcomeEmail Success", data); 
    }, (error) => {
      console.log("sendWelcomeEmail Error", error);
    });
  }

  close() {
    // this.document.body.style.overflow = 'visible';
    this.visible = false; 
    //testing ci/cd for market event dev..second try

    this.closeLogin.emit(false);
  }


}
